import { t } from '$i18n'
import { WithQueryTitleWrapper } from '$common/room-list-search/with-query-title-wrapper/with-query-title-wrapper'
import { WithQueryTitleBase } from '../with-query-title-base'

export function WithQueryPrivateSpaceListItemTitle({
  query,
}: {
  query: string
}) {
  const title = t('chatList.privateSpace')

  return (
    <WithQueryTitleWrapper>
      <WithQueryTitleBase query={query} title={title} variant="subtitle3" />
    </WithQueryTitleWrapper>
  )
}
